<app-header></app-header>
<div class="header-wrapper">
  <header class="pss-header">
    <div class="container">
      <section class="pss-hiro-section pd-btm-0">
        <div class="pss-banner-caption">
          <!-- <h4>{{ 'HOME.HOMEPAGE.GREETING_MAIN' | translate }}</h4> -->
          <h1>{{ 'HOME.HOMEPAGE.GREETING_SECONDARY' | translate }}</h1>
          <!-- <p>{{ 'HOME.HOMEPAGE.GREETING_CONTENT' | translate }}</p> -->
       
          <!-- <button class="pss-button-primary pss-button-primary__btn-large d-flex-center btn-style" (click)="scrollToSection(videosection)">
            {{ 'HOME.HOMEPAGE.LEARN_MORE' | translate }}
            <mat-icon>arrow_right_alt</mat-icon>
          </button> -->
        </div>
      </section>
    </div>
    <div class="scroll-hint" (click)="scrollToSection(videosection)"></div>
  </header>
</div>

<section class="pss-bg-white pd-btm-1" #videosection>
  <div class="container">
    <div class="side-header">
      <h2>What is ALM Studio?</h2>
    </div>
    <div class="video-section">
      <div class="video-container">
        <video controls [poster]="thumbnailUrl">
          <source src="assets/SKO - Icertis ALM Studio 2.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="description">
         <p>Icertis Application Lifecycle Management (ALM) Studio is a collection of self-service tools designed to assist implementation and support teams of customers and partners in managing the entire lifecycle of the Icertis platform, from setup to support. </p> <p> With these tools, customers and partners can set up their Icertis platform, develop and deploy technical configurations, and use system tools to independently debug and resolve support issues.</p>
      </div>
    </div>
  </div>
  
</section>

<!-- <section class="pss-bg-white pd-btm-0">
  <div class="container">
    <div class="side-header">
      <h2>Value</h2>
    </div>
    <div class="value-section">
      <div class="value">
        <h3 class="value-header"> Aligning with a Dynamic Business Environment </h3>
        <ul>
          <li>With rapidly changing business needs, businesses need the ability to adapt their contract intelligence platform, from setup to support.</li>
          <li>The adaptability coversdeveloping technical configurations on the platform, setting up instances  on-demand and resolving issues with application environments.</li>
        </ul>
      </div>
      <div class="value">
        <h3 class="value-header"> Taking control of platform lifecycle </h3><br>
        <ul>
          <li>Limited visibility into application provisioning and instance health hinders monitoring maintaining and optimizing application performance.</li>
          <li>Lack of self-service and end-to-end Application Lifecycle Management practices results in inefficiencies and delays in stages from set up till support.</li>
        </ul>
      </div>
      <div class="value">
        <h3 class="value-header">Impact on Market position</h3><br>
        <ul>
          <li>The inability to innovate quickly and effectively in contracting practices hampers organizations’ ability to adapt to changing market needs,</li>
          <li>Companies struggle to keep pace with the market, leading to loss of competitive edge.</li>
        </ul>
      </div>
    </div>
  </div>
</section> -->

<!-- <section class="pss-bg-grey">
  <div class="section-header" #solution>
    <h2>{{ 'HOME.HOMEPAGE.SOLUTION_HEADING' | translate }}</h2>
  </div>

  <div class="pss-offering">
    <div class="card">
      <span class="steps">1</span>
      <mat-icon class="icon" svgIcon="download"></mat-icon>
      <h3 class="heading">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_ONE.HEADING' | translate }}</h3>
      <p class="details">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_ONE.CONTENT' | translate }}</p>
    </div>
    <div class="card">
      <span class="steps">2</span>
      <mat-icon class="icon icon-scale-down" svgIcon="develope"></mat-icon>
      <h3 class="heading">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_TWO.HEADING' | translate }}</h3>
      <p class="details">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_TWO.CONTENT' | translate }}</p>
    </div>
    <div class="card">
      <span class="steps">3</span>
      <mat-icon class="icon" svgIcon="validate"></mat-icon>
      <h3 class="heading">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_THREE.HEADING' | translate }}</h3>
      <p class="details">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_THREE.CONTENT' | translate }}</p>
    </div>
    <div class="card">
      <span class="steps">4</span>
      <mat-icon class="icon" svgIcon="ready"></mat-icon>
      <h3 class="heading">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_FOUR.HEADING' | translate }}</h3>
      <p class="details">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_FOUR.CONTENT' | translate }}</p>
    </div>
    <div class="card">
      <span class="steps">5</span>
      <mat-icon class="icon" svgIcon="ready"></mat-icon>
      <h3 class="heading">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_FIVE.HEADING' | translate }}</h3>
      <p class="details">{{ 'HOME.HOMEPAGE.SOLUTION_CARD_FIVE.CONTENT' | translate }}</p>
    </div>
  </div>
</section> -->

<section class="pss-bg-grey pd-tp-2">
  <div class="section-header" #solution>
    <h2>{{ 'HOME.HOMEPAGE.SOLUTION_HEADING' | translate }}</h2>
  </div>

  <div class="pss-offering">
    <div class="card1">
      <span class="steps">1</span>
      <mat-icon class="icon" svgIcon="platform"></mat-icon>
      <h3 class="heading">Simplify Icertis platform setup</h3>
      <p class="details">Provision Icertis platform instance, admin users and set up integrations with user directory and eSignature with ease.</p>
    </div>
    <div class="card1">
      <span class="steps">2</span>
      <mat-icon class="icon icon-scale-down" svgIcon="tech_congif"></mat-icon>
      <h3 class="heading">Accelerate technical configurations</h3>
      <p class="details">Swiftly build, package, validate, and certify technical configurations, leveraging instant project setup, starter kits of boilerplate code, low code utilities, and integrated certification checks with detailed reports, all tailored for the Icertis platform.</p>
    </div>
    <div class="card1">
      <span class="steps">3</span>
      <img width="66px" height="70px" src="../../../../assets/images/Picture4.svg">
      <h3 class="heading">Manage Icertis instances effectively</h3>
      <p class="details">Empower support teams to monitor and manage Icertis platform instances effectively, leveraging debugging and troubleshooting utilities.</p>
    </div>
  </div>
</section>

<section class="pss-bg-white pd-btm-0">
  <div class="container">
    <!-- <div class="side-header">
      <h2>Value</h2>
    </div> -->
    <div class="value-section">
      <div class="value">
        <div class="side-header icon-header">
          <mat-icon class="icon" svgIcon="manage"></mat-icon><h2> Management Studio </h2>
        </div>
        <ul>
          <li>Manage users and set up role-based access controls, eSignature and Single Sign On (SSO).</li>
          <li>Track instance requests and get status notifications.</li>
          <li>Monitor and report on customer-specific instances by type, status.</li>
          <li>Accelerate issue resolution with debugging utilities.</li>
        </ul>
      </div>
      <div class="value">
        <div class="side-header icon-header">
          <mat-icon class="icon" svgIcon="configuration"></mat-icon><h2> Configuration Studio </h2>
        </div>
        <ul>
          <li>Develop technical configurations, package and deploy across environments.</li>
          <li>Leverage low-code developer tools and boilerplate code with quick set up.</li>
          <li>Get package certified by Icertis to ensure code integrity and compliance with standards using automated checks.</li>
        </ul>
      </div>
      <div class="value">
        <div class="side-header icon-header">
          <mat-icon class="icon integrated-header" svgIcon="integrated"></mat-icon><h2>Integrated Help</h2>
        </div>
        <ul>
          <li>Access comprehensive technical help and FAQs.</li>
          <li>Gain product know-how and expedite troubleshooting.</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- <section class="pss-bg-white pd-btm-0">
  <div class="container">
    <div class="side-header">
      <h2>Management Studio</h2>
    </div>
    <div class="value-section">
      <div class="value theme-block manage-block">
        <mat-icon class="icon icon-scale-down" svgIcon="manage"></mat-icon>
        <span  class="theme-description">Manage users and set up role-based access controls, eSignature and Single Sign On (SSO).</span>
      </div>
      <div class="value theme-block manage-block">
        <mat-icon class="icon icon-scale-down" svgIcon="manage"></mat-icon>
        <span class="theme-description">Track instance requests and get status notifications.</span>
      </div>
      <div class="value theme-block manage-block">
        <mat-icon class="icon icon-scale-down" svgIcon="manage"></mat-icon>
        <span  class="theme-description">Monitor and report on customer-specific instances by type, status.</span>
      </div>
      
      <div class="value theme-block manage-block">
        <mat-icon class="icon icon-scale-down" svgIcon="manage"></mat-icon>
        <span  class="theme-description">Accelerate issue resolution with debugging utilities.</span>
      </div>
    </div>
  </div>
</section>

<section class="pss-bg-white pd-btm-0 pd-tp-0">
  <div class="container">
    <div class="side-header">
      <h2>Configuration Studio</h2>
    </div>
    <div class="value-section">
      <div class="value theme-block">
        <mat-icon class="icon icon-scale-down" svgIcon="configuration"></mat-icon>
        <span class="theme-description">Develop technical configurations, package and deploy across environments</span>
      </div>
      <div class="value theme-block">
        <mat-icon class="icon icon-scale-down" svgIcon="configuration"></mat-icon>
        <span  class="theme-description">Leverage low-code developer tools and boilerplate code with quick set up</span>
      </div>
      <div class="value theme-block">
        <mat-icon class="icon icon-scale-down" svgIcon="configuration"></mat-icon>
        <span  class="theme-description">Get package certified by Icertis to ensure code integrity and compliance with standards using automated checks.</span>
      </div>
    </div>
  </div>
</section>




<section class="pss-bg-white pd-btm-0 pd-tp-0">
  <div class="container">
    <div class="side-header">
      <h2>Integrated Help</h2>
    </div>
    <div class="value-section">
      <div class="value theme-block intrgrate-block">
        <mat-icon class="icon icon-scale-down" svgIcon="integrated"></mat-icon>
        <span class="theme-description">Access comprehensive technical help and FAQs.</span>
      </div>
      <div class="value theme-block intrgrate-block">
        <mat-icon class="icon icon-scale-down" svgIcon="integrated"></mat-icon>
        <span  class="theme-description">Gain product know-how and expedite troubleshooting.</span>
      </div>
    </div>
  </div>
</section> -->
<!-- 
<section class="pss-bg-white pd-tp-0">
  <div class="container">
    <div class="section-header">
      <h2>{{ 'HOME.HOMEPAGE.PARTNER_HEADING' | translate }}</h2>
    </div>
    <div class="partner-logo-wrapper">
      <div class="logo">
        <img src="../../../../assets/images/partners/microsoft.png" alt="Microsoft">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/accenture.png" alt="Accenture">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/docusign.png" alt="Docusign">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/whatfix.png" alt="whatfix">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/adobe.png" alt="Adobe">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/sap.png" alt="SAP">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/wipro.png" alt="Wipro">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/tcs.png" alt="TCS">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/pwc.png" alt="PWC">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/box.png" alt="box">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/deloitte.png" alt="Deloitte">
      </div>
      <div class="logo">
        <img src="../../../../assets/images/partners/workday.png" alt="Workday">
      </div>
    </div>
  </div>
</section> -->
<!-- <section class="pss-bg-grey">
  <div class="container">
    <div class="pss-testimonial">
      <div class="heading">
        <h2>{{ 'HOME.HOMEPAGE.TESTIMONIAL.HEADING_ONE' | translate }}<br>{{ 'HOME.HOMEPAGE.TESTIMONIAL.HEADING_TWO' | translate }}</h2>
      </div>
      <div class="testimonial">
        <div class="avatar">UO</div>
        <p>{{ 'HOME.HOMEPAGE.TESTIMONIAL.ITEM_ONE.CONTENT' | translate }}</p>
        <div class="author">
          <h3>{{ 'HOME.HOMEPAGE.TESTIMONIAL.ITEM_ONE.AUTHOR_NAME' | translate }}</h3>
          <p>{{ 'HOME.HOMEPAGE.TESTIMONIAL.ITEM_ONE.AUTHOR_COMPANY' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section> -->
<app-footer></app-footer>
